import React, { useState } from "react";
import axiosInstance from "../api/axiosInstance"; // Replace with your axios instance
import "../styles/search.css"; // CSS for styling

const Search = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchQuery) return;

    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.get(`/search/users/?query=${searchQuery}`);
      setSearchResults(response.data.users || []);
    } catch (err) {
      console.error("Search error:", err);
      setError("Failed to fetch search results.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="search-container">
      <form className="search-form" onSubmit={handleSearch}>
        <input
          type="text"
          className="search-input"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <button type="submit" className="search-button">Search</button>
      </form>
      {loading && <div className="loading-message">Loading...</div>}
      {error && <div className="error-message">{error}</div>}
      <div className="results-container">
        {searchResults.map((user) => (
          <div key={user.id} className="user-card">
            <img
              src={user.profilePictureUrl || "/assets/images/default_profile.png"}
              alt={`${user.username}'s profile`}
              className="user-avatar"
            />
            <div className="user-info">
              <h3 className="user-username">{user.username}</h3>
              <p className="user-email">{user.email}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Search;